import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {BlocksControls, InlineImage, InlineTextarea} from 'react-tinacms-inline';
import {Content} from '../Common/Content';
import {ImageStyled} from '../Common/ImageStyled';
import {featureTemplate} from '../../constants/templates/features';
import {FeatureBodyStyled} from './FeatureBodyStyled';
import classNames from 'classnames';
import {useBlockProps} from '../../hooks/useBlockProps';
import {usePage} from '../../contexts/PageContext';
import {featureFields} from '../../constants/fields/feature.fields';
import {getMediaURL} from '../../utils/renderMedia';
import {H3, P} from '../Common/Titles';

function FeatureComponent({index, data}) {
  const {blockProps} = useBlockProps(data);
  const {language} = usePage();
  const {showImage} = data.media || {};

  const {titleProps, secondaryProps, media, props,} = useMemo(() => {
    const {titleProps, secondaryProps, title, media, ...props} = blockProps;

    return {
      titleProps,
      secondaryProps,
      title, media,
      props
    };
  }, [blockProps]);
  return (
    <div>
      <BlocksControls index={index} focusRing={{offset: 0}}>
        <Content {...props}
          className={
            classNames(
              `p-0 flex shadow-${blockProps.shadow}`,
              media.position !== 'top' ? 'flex-row' : 'flex-col'
            )}>
          {showImage === 'true' &&
          <ImageStyled {...media} viewport={blockProps.viewport}>
            <InlineImage
              name="media.src"
              parse={({src}) => src}
              uploadDir={() => '/'}
              previewSrc={(src) => getMediaURL(src)}
              focusRing={false}
              alt={media?.alt}
            >
              {(({src, alt}) => <img src={getMediaURL(src)} alt={alt}/>)}
            </InlineImage>
          </ImageStyled>
          }
          <FeatureBodyStyled className={'dfl-cms-feature-body flex-grow'} box={blockProps.box} viewport={blockProps.viewport}>
            <H3 className={'mb-2'} {...titleProps}>
              <InlineTextarea name={`title.${language}`} focusRing={false}/>
            </H3>
            <P className={'my-2'} {...secondaryProps}>
              <InlineTextarea name={`subText.${language}`} focusRing={false}/>
            </P>
          </FeatureBodyStyled>
        </Content>
      </BlocksControls>
    </div>
  );
}

const template = {
  label: 'Feature',
  defaultItem: featureTemplate,
  fields: featureFields
};
export const Feature = {
  Component: FeatureComponent,
  template
};

FeatureComponent.propTypes = {
  data: PropTypes.object,
  index: PropTypes.number
};
